import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, Divider } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.dark',
        color: 'white',
        pt: 6,
        pb: 3,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* About Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              ICAR–Directorate of Floricultural Research
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
              Advancing excellence in floricultural research and providing
              world-class training programs for professionals and students.
            </Typography>
            <Box display="flex" gap={1}>
              <IconButton
                size="small"
                sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
                component="a"
                href="https://www.facebook.com/profile.php?id=100064798773671"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FacebookIcon />
              </IconButton>

              <IconButton
                size="small"
                sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
                component="a"
                href="https://x.com/ICAR_DFR"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <TwitterIcon />
              </IconButton>

              <IconButton
                size="small"
                sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
                component="a"
                href="https://www.youtube.com/@ICAR-DirectorateofFloricultur"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <YouTubeIcon />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Quick Links
            </Typography>
            <Box display="flex" flexDirection="column" gap={1}>
              <Link href="/" color="inherit" underline="hover" sx={{ opacity: 0.9 }}>
                Home
              </Link>
              <Link href="/courses" color="inherit" underline="hover" sx={{ opacity: 0.9 }}>
                Courses
              </Link>
              <Link href="/about" color="inherit" underline="hover" sx={{ opacity: 0.9 }}>
                About Us
              </Link>
              <Link href="/contact" color="inherit" underline="hover" sx={{ opacity: 0.9 }}>
                Contact
              </Link>
            </Box>
          </Grid>

          {/* Resources */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Resources
            </Typography>
            <Box display="flex" flexDirection="column" gap={1}>
              <Link href="#" color="inherit" underline="hover" sx={{ opacity: 0.9 }}>
                Training Materials
              </Link>
              <Link href="#" color="inherit" underline="hover" sx={{ opacity: 0.9 }}>
                Research Publications
              </Link>
              <Link href="#" color="inherit" underline="hover" sx={{ opacity: 0.9 }}>
                FAQs
              </Link>
              <Link href="#" color="inherit" underline="hover" sx={{ opacity: 0.9 }}>
                Privacy Policy
              </Link>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Contact Us
            </Typography>
            <Box display="flex" flexDirection="column" gap={1.5}>
              <Box display="flex" alignItems="flex-start" gap={1}>
                <LocationOnIcon fontSize="small" sx={{ mt: 0.5, opacity: 0.9 }} />
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  ICAR-Directorate of Floricultural Research,
                  Zed Corner, Mundhwa Manjri Road,
                  Mundhwa, Pune 411036,
                  Maharashtra,
                  India.
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <PhoneIcon fontSize="small" sx={{ opacity: 0.9 }} />
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  (020)29997185
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <EmailIcon fontSize="small" sx={{ opacity: 0.9 }} />
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  dfr.technicalteam@gmail.com
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, bgcolor: 'rgba(255,255,255,0.2)' }} />

        <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap={2}>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            © {currentYear} ICAR-Directorate of Floricultural Research. All rights reserved.
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Designed by:{' '}
            <Link href="#" color="inherit" underline="hover" sx={{ fontWeight: 600 }}>
              Saurabh Sapkal
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
